import { ProductionDeviationForm } from "features/CenterContent/RoleContent/ProductionDeviation/types/formSchema";
import { TrainSerieDisplay } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/components/TrainSerieDisplay";
import { PRODUCTION_DEVIATION_LOCATION_HASH } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  DialogBody,
  DialogFooter,
  DialogRoot,
  DropsButton,
  DropsDialogContent,
  DropsDialogHeader,
  Flex,
  Text,
  TextLink,
} from "shared/components/Spor";

interface ConfirmProductionDeviationModalProps {
  isEditMode: boolean;
  trainSeries: string[];
  onClose: () => void;
}

const ConfirmProductionDeviationModal: FC<
  ConfirmProductionDeviationModalProps
> = ({ isEditMode, trainSeries, onClose }) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<ProductionDeviationForm>();
  return (
    <DialogRoot open onOpenChange={onClose} size="lg" placement="center">
      <DropsDialogContent maxWidth="500px">
        <DropsDialogHeader>
          <Text fontSize="24px">
            {isEditMode
              ? t("Produksjonsavvik endret")
              : t("Produksjonsavvik opprettet")}
          </Text>
        </DropsDialogHeader>
        <DialogBody display="flex" flexDirection="column" gap="12px" p="24px">
          <Text fontWeight={600}>
            {t("For togserien", { count: trainSeries.length })}
          </Text>
          <Flex flexWrap="wrap" gap="12px">
            {trainSeries?.map((series) => (
              <TrainSerieDisplay
                trainIds={getValues(
                  `productionDeviationForm.${series}.selectedTrains`,
                )}
              />
            ))}
          </Flex>

          <Text mb="12px">
            {t("Hendelsene kan redigeres eller friskmeldes fra ")}
            <TextLink
              onClick={() => {
                onClose();
                window.location.hash = PRODUCTION_DEVIATION_LOCATION_HASH;
              }}
            >
              {t("Oversikt")}
            </TextLink>
          </Text>
        </DialogBody>
        <DialogFooter>
          <DropsButton onClick={onClose}>{t("Lukk")}</DropsButton>
        </DialogFooter>
      </DropsDialogContent>
    </DialogRoot>
  );
};

export default ConfirmProductionDeviationModal;
